export default __webpack_public_path__ + "static/media/shutterstock_616060073.d728ebc0.png";